import { render, staticRenderFns } from "./utility-service-qualification-5g-result.vue?vue&type=template&id=6c4307a9&scoped=true&"
import script from "./utility-service-qualification-5g-result.vue?vue&type=script&lang=js&"
export * from "./utility-service-qualification-5g-result.vue?vue&type=script&lang=js&"
import style0 from "./utility-service-qualification-5g-result.vue?vue&type=style&index=0&id=6c4307a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4307a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
installComponents(component, {VFlex,VIcon,VLayout,VList,VListTile})
